/*
 * Developed for G.J. Gardner Homes by Softeq Development Corporation
 * http://www.softeq.com
 */

import { Injectable } from '@angular/core';
import { ID } from '@gh/common-shared-data';
import { SlicedDataSource } from '@gh/core-data';
import { SupplierUserContext } from '@gh/supplier-shared';
import { SupplierPurchaseOrdersRestService } from '@gh/supplier-shared-data';
import { Observable } from 'rxjs';
import { PurchaseOrdersModel } from '../models';

@Injectable()
export class SupplierPurchaseOrderListBusinessService {
  constructor(
    private userContext: SupplierUserContext,
    private restService: SupplierPurchaseOrdersRestService,
  ) {
  }

  findAll(showRejected: boolean, officeId?: ID): SlicedDataSource<PurchaseOrdersModel> {
    return this.restService.findAll(showRejected, officeId);
  }

  accept(orderId: ID, version: number): Observable<PurchaseOrdersModel> {
    return this.restService.acceptOrder(orderId, version);
  }

  reject(orderId: ID, version: number): Observable<PurchaseOrdersModel> {
    return this.restService.rejectOrder(orderId, version);
  }
}
